import { render, staticRenderFns } from "./CalcShipping.vue?vue&type=template&id=aea4cc58&"
import script from "./CalcShipping.vue?vue&type=script&lang=js&"
export * from "./CalcShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports